<template>
  <div class="modal-overlay">
    <div class="main">
      <div class="fixed">
        <div class="diss_area">
          <span class="iconfont">&#xe681;&nbsp;讨论区</span>
          <div class="gap"></div>
          <span>{{ discuss_list.length }}条讨论</span>
          <div class="area"></div>
          <div class="close" @click.self="close">&times;</div>
        </div>
        <div class="text_input">
          <textarea id="diss_input" placeholder="评论千万条, 等你发一条![开发者提示:Shift + d 可以快速展开|关闭讨论区]" v-model="diss_input"
            maxlength="999"></textarea>
          <div class="send" @click="sendDisscuss">
            <span class="iconfont">{{ statisDissLen }} / 999</span>
            <span class="iconfont">&#xe893; 发送消息</span>
          </div>
        </div>
      </div>
      <div class="gap2"></div>
      <span class="message iconfont">&#xe891;&nbsp;&nbsp;最新</span>
      <div class="disscuss_container" v-if="this.discuss_list.length > 0">
        <div class="user_input" v-for="item in this.discuss_list" :key="item.id">
          <div class="userinfo">
            <img :src="item.title" alt="">
            <div style="height: 10px;"></div>
          </div>
          <div class="input_contents">
            <span class="username">{{ item.name }}</span>
            <span class="userinput_content">{{ item.input }}</span>
            <span class="other">{{ item.time }}</span>
          </div>
          <div class="handle">
            <div class="gap">
              <div class="handle_box">
                <div class="identify_count iconfont">&#xe6b6; {{ item.likes_count }}</div>
                <div class="identify iconfont" @click="identifyDisscussion(item.id, item.is_my_like)">&#xe67b; 赞同</div>
                <div class="delete iconfont"
                  @click="(dialogVisible = true, msg = '将永久删除此留言,请小心操作!', tempId = item.id, pattern = 'delete')">
                  &#xe63a; 删除</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="disscuss_container" v-else>
        <div class="no_data iconfont">&#xe6f4;当前留言板为空</div>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" height="20%" class="custom-dialog" :modal="false"
      :destroy-on-close=true>
      <span class="text">{{ msg }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancle" @click="dialogVisible = false">取 消</el-button>
        <el-button class="ok" type="primary" @click="dialog(tempId, pattern)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getDiscussionList, postDiscussion, deleteDiscussion, approvedDiscussion } from '@/utils/getDisscussBoard'
import { Message } from 'element-ui'
import theme from '@/utils/theme'
import localStorageUtils from '@/utils/setLocalStorage'
export default {
  name: 'DiscussionBoard',
  props: {
    boardvisible: {
      type: Boolean,
      default: false
    },
    disscussType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      discuss_list: [],
      diss_input: '',
      container: 0,
      positon: 0,
      status: false,
      loading: false,
      day: theme.day, // 主题设置
      night: theme.night,
      theme: true,
      dialogVisible: false,
      msg: '',
      tempId: null,
      pattern: null
    }
  },
  async created() {
    // 获取主题
    if (localStorageUtils.getItem('theme') !== null) {
      this.theme = localStorageUtils.getItem('theme')
    } else {
      this.theme = true
    }
    await this.handleDisscussboard()
  },
  mounted() {
    // 初始化讨论区状态
    const main = document.querySelector('.modal-overlay')
    main.style.left = '100%'
    main.style.transition = 'all 0.0s'
    // 添加键盘事件监听器
    window.addEventListener('keydown', this.handleKeystart)
    window.addEventListener('keydown', this.handleEsc)
    // 初始化主题效果
    this.$nextTick(() => {
      this.source_html()
    })
  },
  watch: {
    boardvisible: function (newVal) {
      if (newVal) {
        const main = document.querySelector('.modal-overlay')
        main.style.left = '0%'
        main.style.transition = 'all 0.8s'
      }
    }
  },
  methods: {
    // 获取留言列表
    async handleDisscussboard() {
      try {
        const params = {
          type: this.disscussType,
          page: 1,
          limit: 99999
        }
        const res = await getDiscussionList(params)
        const data = res.data.remarks.data
        this.discuss_list = []
        data.forEach(item => {
          const user_info = {
            id: item.id,
            title: item.user_avatar,
            name: item.user_name,
            input: item.content,
            time: item.created_at,
            likes_count: item.likes_count,
            is_my_like: item.is_my_like
          }
          this.discuss_list.push(user_info)
        })
      } catch (error) {
        Message.warning('请求失败，请稍后再试！')
      }
    },
    // 发送留言
    async sendDisscuss() {
      try {
        if (this.diss_input.length > 0 || this.statisDissLen.length <= 420) {
          const params = {
            type: this.disscussType,
            content: this.diss_input
          }
          await postDiscussion(params)
          this.diss_input = ''
          this.handleDisscussboard()
          Message.success('发送留言成功!')
        } else {
          Message.warning('评论内容不能为空,请输入内容!')
        }
      } catch (error) {
        Message.warning('请求失败,查看内容是否过多,请适当删除内容!')
      }
    },
    // 点赞留言
    async identifyDisscussion(id, like) {
      try {
        const params = {
          id: id
        }
        if (like === 0) {
          await approvedDiscussion(params)
          this.handleDisscussboard()
          Message.success('点赞成功!')
        } else {
          this.dialogVisible = true
          this.msg = '你已经点赞过此留言,再次点击将取消点赞,是否取消该赞同!'
          this.pattern = 'cancel'
          this.tempId = id
        }
      } catch (error) {
        Message.warning('请求失败，请稍后再试！')
      }
    },
    // 删除留言
    async deleteDiscussion(id) {
      try {
        const params = {
          id: id
        }
        await deleteDiscussion(params)
        this.handleDisscussboard()
      } catch (error) {
        Message.warning(error)
      }
    },
    // 关闭讨论区
    close() {
      this.$emit('update:boardvisible', false)
      const main = document.querySelector('.modal-overlay')
      main.style.left = '100%'
      main.style.transition = 'all 0.8s'
    },
    // 添加开始快捷键
    handleKeystart(event) {
      // 检查是否按下了 Shift + d
      if (event.shiftKey && event.key === 'D') {
        event.preventDefault() // 阻止默认行为（可选）
        event.stopPropagation()
        if (this.boardvisible) {
          this.$emit('update:boardvisible', false)
          const main = document.querySelector('.modal-overlay')
          main.style.left = '100%'
          main.style.transition = 'all 0.8s'
        } else {
          this.$emit('update:boardvisible', true)
          const main = document.querySelector('.modal-overlay')
          main.style.left = '0%'
          main.style.transition = 'all 0.8s'
        }
      }
    },
    // Dialog点击执行方法
    async dialog(id, module) {
      try {
        if (module === 'delete') {
          await this.deleteDiscussion(id)
          this.dialogVisible = false
        }
        if (module === 'cancel') {
          await approvedDiscussion({ id: this.tempId })
          this.handleDisscussboard()
          Message.success('取消点赞成功!')
          this.dialogVisible = false
        }
      } catch (error) {
        Message.warning('请求失败，请稍后再试！')
      }
    },
    // 初始化效果
    source_html() {
      const main = document.querySelector('.modal-overlay .main')
      const fixed = document.querySelector('.modal-overlay .main .fixed')
      main.style.background = this.theme ? this.day : this.night
      main.style.boxShadow = this.theme ? '0 0 20px rgba(0, 0, 0, 0.2)' : '0 0 50px rgba(255, 255, 255, 0.5)'
      fixed.style.background = this.theme ? this.day : this.night
    }, // 退出
    handleEsc(event) {
      if (event.key === 'Escape') {
        this.close()
      }
      if (event.shiftKey && event.key === 'E') {
        this.close()
      }
    }
  },
  computed: {
    statisDissLen() {
      return this.diss_input.length
    }
  },
  beforeDestroy() {
    // 移除键盘事件监听器
    window.removeEventListener('keydown', this.handleKeystart)
    window.removeEventListener('keydown', this.handleEsc)
  }

}
</script>

<style lang="less" scoped>
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

@keyframes opacity {
  0% {
    border: 2px solid rgba(150, 150, 150, 0.5);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  }

  50% {
    border: 2px solid rgba(150, 150, 150, 0.1);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }

  100% {
    border: 2px solid rgba(150, 150, 150, 0.5);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  }
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.iconfont {
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 25px;
}

// 弹窗
.custom-dialog {
  .custom-dialog .el-dialog__header {
    background-color: #eef1f6;
    border-bottom: 1px solid #dcdfe6;
    text-align: center;
  }

  .custom-dialog .el-dialog__footer {
    text-align: center;
  }

  .dialog-footer .el-button {
    margin: 0 5px;
    border: 1px solid @basicselect;
    color: @font_gray;
    border-radius: 10px;
    transition: all 0.5s;

    &:hover {
      transition: all 0.5s;
      background-color: @morejoy;
      color: @font_white;
    }
  }

  .ok,
  .cancle {
    background-color: white;
    display: inline-block;
    padding: 12px 15px;
    font-size: 22px;
  }

  span {
    font-size: 22px;
    color: @font_gray;
  }

}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  /* 半透明遮罩 */
  display: flex;
  z-index: 99;
  transition: all 0.5s;

  .main {
    position: absolute;
    top: 0;
    left: 760px;
    width: 1800px;
    padding: 0px 20px;
    height: 100vh;
    transition: all 0.5s;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
    overflow-y: scroll;
    background-color: rgb(255, 255, 255);

    .fixed {
      position: fixed;
      width: 1760px;
      height: 285px;
      z-index: 1;
      background-color: rgb(255, 255, 255);

      .diss_area {
        display: flex;
        width: 100%;
        height: 70px;
        color: @font_gray;
        justify-content: space-between;

        span:nth-child(1) {
          display: block;
          height: 70px;
          line-height: 70px;
          font-weight: 500;
          font-size: 28px;
          color: @morejoy;
        }

        .gap {
          width: 10px;
        }

        span:nth-child(3) {
          display: block;
          height: 70px;
          line-height: 70px;
          font-size: 25px;
          color: @morejoy;
          opacity: 0.7;
        }

        .area {
          width: 1480px;
        }

        .close {
          width: 25px;
          height: 70px;
          text-align: center;
          line-height: 70px;
          font-size: 25px;
          cursor: pointer;
        }
      }

      .text_input {
        position: relative;
        width: 100%;
        height: 200px;
        transition: all 0.5s;

        #diss_input {
          position: relative;
          width: 100%;
          height: 200px;
          padding: 15px;
          border: 2px solid rgba(150, 150, 150, 0.673);
          outline: none;
          border-radius: @border_radius;
          resize: none;
          font-size: 23px;
          font-family: '微软雅黑';
          color: @font_gray;
          transition: all 0.5s;

          &:active,
          &:hover,
          &:focus {
            transition: all 0.5s;
            animation: opacity 2s infinite;
          }
        }

        .send {
          display: flex;
          justify-content: space-between;
          width: 310px;
          height: 55px;
          position: absolute;
          right: 30px;
          bottom: 30px;
          color: @font_white;
          transition: all 0.5s;

          span:nth-child(1) {
            display: block;
            width: 130px;
            height: 55px;
            text-align: center;
            font-size: 25px;
            line-height: 55px;
            color: @font_gray;
            opacity: 0.7;
            transition: all 0.5s;
            background-color: @font_white;
            border-radius: @border_radius_2;
          }

          span:nth-child(2) {
            display: block;
            width: 170px;
            height: 55px;
            text-align: center;
            font-size: 25px;
            padding: 10px;
            border-radius: @border_radius_2;
            background: @morejoy;
            cursor: pointer;
            transition: all 0.5s;

            &:active {
              padding: 0px 0px 20px 0px;
            }
          }
        }

      }

    }

    .gap2 {
      width: 100%;
      height: 285px;
    }

    .message {
      font-size: 21px;
      color: @font_gray;
    }

    .disscuss_container {
      width: 100%;
      height: calc(100vh - 285px);
      padding: 15px;

      .user_input {
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        height: auto;
        padding: 20px 0px;
        transition: all 0.5s;
        border-bottom: 1px solid rgba(150, 150, 150, 0.2);

        &:hover {
          transition: all 0.5s;
        }

        .userinfo {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: left;
          width: 100px;
          height: 100%;

          img {
            width: 80px;
            height: 80px;
            border-radius: 40px;
            border: 2px solid @basicselect
          }

        }

        .input_contents {
          width: calc(100% - 300px);
          margin-left: 15px;
          gap: 10px;
          display: flex;
          flex-direction: column;

          .username {
            font-size: 20px;
            color: @font_gray;
            opacity: 0.7;
          }

          .userinput_content {
            font-size: 25px;
            color: @font_gray;

          }

          .other {
            font-size: 20px;
            color: @font_gray;
            opacity: 0.7;
          }
        }

        .handle {
          width: 200px;
          height: 100%;

          .gap {
            position: relative !;
            height: 100%;
          }

          .handle_box {
            position: absolute;
            bottom: 20px;
            display: flex;
            justify-content: right;
            gap: 0px 5px;
            width: 200px;
            height: 20px;

            .identify_count {
              display: block;
              width: auto;
              height: 20px;
              font-size: 20px;
              color: @font_gray;
              text-align: center;
              line-height: 20px;
              cursor: pointer;
              transition: all 0.5s;
              opacity: 0.3;

              &:hover {
                transition: all 0.5s;
                transform: scale(1.01);
              }
            }

            .identify,
            .delete {
              display: block;
              width: 70px;
              height: 20px;
              font-size: 20px;
              color: @font_gray;
              text-align: center;
              line-height: 20px;
              cursor: pointer;
              transition: all 0.5s;

              &:hover {
                transition: all 0.5s;
                transform: scale(1.01);
              }
            }
          }

        }
      }

      .no_data {
        width: 100%;
        height: calc(100vh - 285px);
        color: @font_gray;
        font-size: 35px;
        text-align: center;
        line-height: calc(100vh - 285px);
      }
    }
  }
}
</style>
